<template>
    <BreadCrumb PageTitle="Point des règlements" />
    <PointDesReglements />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import PointDesReglements from "../../components/Etats/PointDesReglements.vue";

    export default defineComponent({
        name: "PointDesReglementsPage",
        components: {
            BreadCrumb,
            PointDesReglements
        },
    });
</script>